import * as types from '../mutation-types'
import { ajaxFun } from '../actions'

// initial state
const state = {
  all: [],
  flag: false,
  time: '',
  studentsAndParents: [],
  flagSp: false,
  timeSp: false,
  length: 0,
  lengthSp: 0
}

// getters
const getters = {
  getStudentsByFirstChar: state => state.all,
  studentLength: state => state.length,
  studentsAndParentsByFirstChar: state => state.studentsAndParents,
  parentsNum: state => state.lengthSp
}

// actions
const actions = {
  // 学生
  clearStudents ({ commit }) {
    commit(types.CLEAR_STUDENTS)
  },

  clearStudentParents ({ commit }) {
    commit(types.CLEAR_STUDENT_PARENTS)
  },

  deleteStudent ({ commit }, studentId) {
    commit(types.DELETE_STUDENT, studentId)
  },

  addToStudents ({ commit }, student) {
    commit(types.ADD_TO_STUDENTS, student)
  },

  receiveStudents ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.flag, state.time, types.RECEIVE_STUDENTS)
  },

  receiveStudentsAndParents ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.flagSp, state.timeSp, types.RECEIVE_STUDENTS_AND_PARENTS)
  }
}

const compare = (propertyName) => {
  return function (object1, object2) {
    var value1 = object1[propertyName]
    var value2 = object2[propertyName]
    if (value2 > value1) {
      return -1
    } else if (value2 < value1) {
      return 1
    } else {
      return 0
    }
  }
}

// mutations
const mutations = {
  [types.RECEIVE_STUDENTS] (state, students) {
    // state.all = students
    state.length = students.length
    state.flag = true
    state.time = new Date().getTime()
    let newArr = []
    // let charList = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    let index = -1
    students.forEach((student, i) => {
      let alreadyExists = newArr.some((newStudent, j) => {
        if (student.firstChar == newStudent.firstChar) {
          index = j
          return true
        }
      })
      if (!alreadyExists) {
        newArr.push({firstChar: student.firstChar, students: [student]})
      } else {
        newArr[index].students.push(student)
      }
    })
    // newArr.sort(compare('firstChar'))
    state.all = newArr.sort(compare('firstChar'))
  },

  [types.RECEIVE_STUDENTS_AND_PARENTS] (state, students) {
    // state.studentsAndParents = students
    state.flagSp = true
    state.timeSp = new Date().getTime()
    let newArr = []
    // let charList = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    let index = -1
    state.lengthSp = 0
    students.forEach((student, i) => {
      state.lengthSp += student.parentList.length
      let alreadyExists = newArr.some((newStudent, j) => {
        if (student.firstChar == newStudent.firstChar) {
          index = j
          return true
        }
      })
      if (!alreadyExists) {
        newArr.push({firstChar: student.firstChar, students: [student]})
      } else {
        newArr[index].students.push(student)
      }
    })
    // newArr.sort(compare('firstChar'))
    state.studentsAndParents = newArr.sort(compare('firstChar'))
  },

  [types.ADD_TO_STUDENTS] (state, student) {
    state.all.push(student)
  },

  [types.CLEAR_STUDENTS] (state) {
    state.flag = false
  },

  [types.CLEAR_STUDENT_PARENTS] (state) {
    state.flagSp = false
  },

  [types.DELETE_STUDENT] (state, studentId) {
    state.all.splice(state.all.findIndex(item => item.studentId == studentId), 1)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/students.js